module.exports = __webpack_public_path__ + "Roboto-Light.woff2?d26871e8149b5759f814fd3c7a4f784b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/Light/Roboto-Light.woff2?v=2.137
// module id = 673
// module chunks = 7